import React from 'react';
import { List, Avatar, Button, Skeleton, Typography } from 'antd';

import reqwest from 'reqwest';

const count = 3;
const fakeDataUrl = `https://randomuser.me/api/?results=${count}&inc=name,gender,email,nat&noinfo`;


class LoadMoreList extends React.Component {
    state = {
      initLoading: true,
      loading: false,
      data: [],
      list: [],
      size:1
    };
  
    componentDidMount() {
      this.getData(res => {
        this.setState({
          initLoading: false,
          data: res.results,
          list: res.results,
        });
      });
    }
  
    getData = callback => {
      reqwest({
        url: fakeDataUrl,
        type: 'json',
        method: 'get',
        contentType: 'application/json',
        success: res => {
          callback(res);
        },
      });
    };
  
    onLoadMore = () => {
      this.setState({
        loading: true,
        list: this.state.data.concat([...new Array(count)].map(() => ({ loading: true, name: {} }))),
      });
      this.getData(res => {
        const data = this.state.data.concat(res.results);
        this.setState(
          {
            data,
            list: data,
            loading: false,
          },
          () => {
            // Resetting window's offsetTop so as to display react-virtualized demo underfloor.
            // In real scene, you can using public method of react-virtualized:
            // https://stackoverflow.com/questions/46700726/how-to-use-public-method-updateposition-of-react-virtualized
            window.dispatchEvent(new Event('resize'));
          },
        );
      });
    };
  
    render() {
      const { initLoading, loading, list } = this.state;
      const loadMore =
        !initLoading && !loading ? (
          <div
            style={{
              textAlign: 'center',
              marginTop: 12,
              height: 32,
              lineHeight: '32px',
            }}
          >
            <Button onClick={this.onLoadMore}>loading more</Button>
          </div>
        ) : null;
 
    const data = [
        'Racing car sprays burning fuel into crowd.',
        'Japanese princess to wed commoner.',
        'Australian walks 100km after outback crash.',
        'Man charged over missing wedding girl.',
        'Los Angeles battles huge wildfires.',
        ];        

      return (
        <List
            header={<div>실습 날짜</div>}
            footer={<div>Footer</div>}
            bordered
            dataSource={data}
            renderItem={item => (
            <Skeleton avatar title={false} loading={item.loading} active>
            <List.Item>
            <Button onClick={
              function() {this.props.onClick(this.state.size)
              }.bind(this)
            } 
            // <Button onClick={function() {
            //   store.dispatch({type:'INCREMENT', size:this.state.size})
            // }.bind(this)}
            >UP</Button>
            <Typography.Text mark>[ITEM]</Typography.Text> {item}
            </List.Item>
            </Skeleton>
            )}
        />
      );
    }
  }
  

export default LoadMoreList;